import { isNullOrUndefined as isNOU } from '@syncfusion/ej2-base';
import * as events from '../base/events';
/**
 * The `Base` module.
 */
export class Base {
    constructor(parent, module) {
        this.parent = parent;
        this.module = module;
        this.addEventListener();
    }
    render(e) {
        this.module.render(e);
    }
    showPopup() {
        this.module.showPopup();
    }
    focus() {
        this.module.focus();
    }
    update(e) {
        this.module.updateValue(e);
    }
    getValue() {
        this.module.getRenderValue();
    }
    destroyComponent() {
        if (isNOU(this.module.compObj)) {
            return;
        }
        this.module.compObj.destroy();
        this.module.compObj = undefined;
    }
    destroy() {
        this.destroyComponent();
        this.removeEventListener();
    }
    addEventListener() {
        this.parent.on(events.render, this.render, this);
        this.parent.on(events.setFocus, this.focus, this);
        this.parent.on(events.showPopup, this.showPopup, this);
        this.parent.on(events.update, this.update, this);
        this.parent.on(events.accessValue, this.getValue, this);
        this.parent.on(events.destroyModules, this.destroyComponent, this);
        this.parent.on(events.destroy, this.destroy, this);
    }
    removeEventListener() {
        if (this.parent.isDestroyed) {
            return;
        }
        this.parent.off(events.render, this.render);
        this.parent.off(events.setFocus, this.focus);
        this.parent.off(events.showPopup, this.showPopup);
        this.parent.off(events.update, this.update);
        this.parent.off(events.accessValue, this.getValue);
        this.parent.off(events.destroyModules, this.destroyComponent);
        this.parent.off(events.destroy, this.destroy);
    }
}
